export const Integrators = {
    payrollConnector: 'payrollConnector',
    checkmate: 'checkmate',
    pointy: 'pointy',
    techPortal: 'techPortal',
    mobileInventory: 'mobileInventory',
    mobileManager: 'mobileManager',
    como: 'como',
};
